import { forwardRef } from 'react';

import { SvgIcon } from '@material-ui/core';
import type { SvgIconProps, Theme } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import {
  CIRCLE_RADIUS,
  ICON_PADDING,
  ICON_VIEWBOX,
  STROKE_WIDTH,
  getColorsClasses,
} from './constants';
import { Color } from './types';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: ICON_PADDING,
      opacity: 0.5,
    },
    ...getColorsClasses(theme),
  });

type ArchivedProps = Omit<SvgIconProps, 'classes' | 'children' | 'color'> &
  WithStyles<typeof styles> & {
    color?: Color;
    error?: boolean;
  };

const ArchivedIcon = forwardRef<SVGSVGElement, ArchivedProps>((props, ref) => {
  const {
    classes,
    className,
    color: colorProp = 'secondary',
    error,
    ...otherProps
  } = props;

  return (
    <SvgIcon
      ref={ref}
      viewBox={ICON_VIEWBOX}
      className={classNames(
        classes.root,
        classes[`${colorProp}Color`],
        className,
      )}
      {...otherProps}
    >
      <circle
        cx="12"
        cy="12"
        r={CIRCLE_RADIUS}
        fill="none"
        stroke="currentColor"
        strokeWidth={STROKE_WIDTH}
      />
      {error ? (
        <path
          d="M8 16l8-8"
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE_WIDTH}
        />
      ) : (
        <path
          d="M9 12l2 2 4-4"
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE_WIDTH}
        />
      )}
    </SvgIcon>
  );
});

ArchivedIcon.displayName = 'StateIcon.ArchivedIcon';

export default withStyles(styles)(ArchivedIcon);
